import {
  MOIGOIHOMSAU_COUNT_ASSIGN_SUCCESS,
  MOIGOIHOMSAU_HISTORY_LIST_SUCCESS,
  MOIGOIHOMSAU_IMPORT_SUCCESS,
  MOIGOIHOMSAU_LIST_SUCCESS,
  MOIGOIHOMSAU_NEW_CARE_SUCCESS,
  MOIGOIHOMSAU_ONE_SUCCESS,
  MOIGOIHOMSAU_UPDATE_FILTER,
} from 'src/actions/moigoihomsau.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const moigoihomsauReducer = (state = initState, action) => {
  switch (action.type) {
    case MOIGOIHOMSAU_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case MOIGOIHOMSAU_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case MOIGOIHOMSAU_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case MOIGOIHOMSAU_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case MOIGOIHOMSAU_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case MOIGOIHOMSAU_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case MOIGOIHOMSAU_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default moigoihomsauReducer